import { extendTheme } from "@chakra-ui/react";
import { bankingRightTheme } from "@bankingright-dashboard/theme";

export const doecoeTheme = extendTheme(bankingRightTheme);
